import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Switch } from '@material-ui/core';

const ButtonSwitch = ({
    label,
    ...otherProps
}) => (
    <FormControlLabel
        control={(
            <Switch
                color="primary"
                {...otherProps}
            />
        )}
        label={label}
    />
);

ButtonSwitch.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};
export default ButtonSwitch;
